import React from "react";
import "./PracticePage.css";

function PracticePage() {
  return (
    <div className="practice">
      <div className="container_all">
        <div className="title_practice">
          <h4>Практичне навчання та працевлаштування</h4>
        </div>
        <div className="text_practice">
          <p>
            Практичне навчання в технікумі проводиться відповідно до вимог
            діючого "Положення про проведення практики студентів вищих
            навчальних закладів" і є невід'ємною органічною складовою частиною
            всього навчально-виховного процесу у професійному становленні
            майбутнього фахівця.
          </p>
          <p>
            Практика студентів разом з іншими видами і формами навчальної роботи
            дає можливість належно оволодівати фахом молодшого спеціаліста:
            бухгалтера, товарознавця-комерсанта, техніка-технолога, отримати
            наукову і практичну підготовку. Практика готовить майбутніх
            спеціалістів до практичної роботи, формує у студентів професійні
            навички, здібність прийняти самостійні рішення на конкретних
            ділянках роботи в реальних конкретних умовах ринкової економіки,
            виховати потребу систематично поповнювати свої знання і творчо їх
            застосовувати в майбутній професії.
          </p>
          <div className="list_practice">
            <h3>Навчальними планами передбачені такі види практик:</h3>
            <ul>
              <li>
                спеціальність "Бухгалтерський облік": навчальна і виробнича
                (технологічна);
              </li>
              <li>
                спеціальність "Товарознавство та комерційна діяльність":
                навчальна і технологічна;
              </li>
              <li>
                спеціальність "Виробництво харчової продукції": навчальна,
                технологічна і переддипломна.
              </li>
            </ul>
          </div>
          <p>
            {" "}
            Всі види практик студенти проходять лише на діючих підприємствах і
            організаціях торгівлі і ресторанного господарства різних форм
            власності м.Чернівці, з якими укладені відповідні угоди: ТОВ
            "Гастроном 148", КВП фірма "Ліна", ТОВ "Ресторан "Україна",
            ресторани "Шарм", "Барон Гартенберг", "Буковинська зірка", ТОВ
            "Епіцентр", ТОВ "Караван", ТОВ "Універсам", ТОВ "ФОЗЗІ-ФУД".
          </p>
          <p>
            {" "}
            Практикується, за згодою керівників підприємств, направлення
            студентів для проходження переддипломної практики за місцем їх
            проживання і з подальшим закріпленням їх на роботі через відповідно
            укладені угоди.
          </p>
          <p>
            Скільки турбот у заступника директора з навчально-виробничої роботи
            Голішко Ганни Олексіївни, влаштовуючи на переддипломну практику
            кожного студента в окрему торговельну точку.
          </p>
          <p>
            По завершенні практики студенти здають кваліфікаційні екзамени на
            предмет присвоєння робітничої професії
            <span>"кухар ІV-V розряду"</span> та{" "}
            <span>"продавець ІІ-І категорії"</span>.
          </p>
          <div className="poem">
            <p>
              Вже ціле місто ваших фахівців,
              <br />
              вже ціле місто наших вихованців.
              <br />
              Спасибі, що плекаєте знавців:
              <br />
              і кухарів, і бухгалтерів,
              <br />і комерсантів, і товарознавців!
            </p>
          </div>
          <div className="list_practice">
            <p>
              Cтуденти Чернівецького державного комерційного технікуму проходять
              практику на сучасних торговельних підприємствах міста з широким
              асортиментом товарів, новим обладнанням та різними формами продажу
              товарів, які дають змогу студентам відпрацювати елементи
              торгово-технологічного процесу і навчальну програму.
            </p>
            <h3>Серед них:</h3>
            <ul>
              <li>товариство з обмеженою відповідальністю «Гастроном 148»;</li>
              <li>
                колективно-виробниче підприємство «Ліна» (магазини № 3, 5, 49);
              </li>
              <li>магазин мережі «Сільпо» в Торговельному центрі «Майдан».</li>
            </ul>
          </div>
          <p>
            Вагомим чинником є високий рівень кваліфікації керівників практики
            від підприємств. Серед них є випускники технікуму з великим стажем
            та досвідом роботи як практичної, так і роботи зі студентами.
          </p>
          <p>
            Випускники технікуму є конкурентоспроможними на ринку праці, мають
            ґрунтовну теоретичну підготовку та практичні навички для активної
            творчої, професійної та соціальної діяльності, про що свідчать
            відгуки з підприємств, де працевлаштовані наші вихованці.
          </p>
          <p>
            Вони показують добрі знання, вміння вирішувати виробничі ситуації,
            діяти в нестандартних умовах ринкових відносин, займають керівні
            посади у сфері торгівлі, є директорами підприємств різних форм
            власності.
          </p>
          <p>
            Праця викладачів, майстрів виробничого навчання увінчується
            молодими, талановитими випускниками. Вони працюють керівниками
            торговельних підприємств, товарознавцями – комерсантами,
            завідувачами складів, торговельними агентами, менеджерами.
          </p>
          <div className="list_practice">
            <p>
              Цікаво та з користю проходять заходи під час проведення місячника
              популяризації професії товарознавця-комерсанта.
            </p>
            <h3>Серед них:</h3>
            <ul>
              <li>товариство з обмеженою відповідальністю «Гастроном 148»;</li>
              <li>
                колективно-виробниче підприємство «Ліна» (магазини № 3, 5, 49);
              </li>
              <li>магазин мережі «Сільпо» в Торговельному центрі «Майдан».</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PracticePage;
